import { GridFilterItem } from "@mui/x-data-grid-pro";
import queryString from "query-string";
import { useCallback } from "react";
import { Link, To } from "react-router-dom";
import { ArrayParam, encodeQueryParams } from "use-query-params";

export function useRenderLink() {
  const renderCellLink = useCallback(
    (
      params,
      view: string,
      search?: GridFilterItem[],
      applyCustomStyle = false
    ) => {
      let value = params.value;
      const style = applyCustomStyle
        ? {
            color: "black",
            fontWeight: "bold",
            textDecoration: "none",
          }
        : params.style || {};

      const to: To = { pathname: view };
      if (search && search.length > 0) {
        const filter: string[] = [];
        for (const s of search) {
          filter.push(JSON.stringify(s));
        }

        const encodedSearch = encodeQueryParams(
          { filter: ArrayParam },
          { filter }
        );
        to.search = queryString.stringify(encodedSearch);
      }

      // ⚠️ DO NOT re-invoke params.colDef.valueFormatter(params) here. This
      // codebase's valueFormatters use the CURRENT MUI X signature —
      // (value, row, column, apiRef) => string, raw value first — not the
      // legacy (params) => string shape. Calling `colDef.valueFormatter(params)`
      // hands a column's formatter the whole GridRenderCellParams object as its
      // "value" argument. A formatter that returns its input unchanged for any
      // non-zero/non-empty input (e.g. `(value) => value === 0 ? "" : value`,
      // the ordinary shape for "pass numbers through, blank out zero") then
      // returns that object right back out — which gets rendered as-is inside
      // <Link>{value}</Link>: React error #31, "object with keys {id, field,
      // row, rowNode, colDef, cellMode, hasFocus, tabIndex, value,
      // formattedValue, isEditable, api}". This crashed the Sentry error
      // boundary on Inventory > Parts > Items, and it does not recover — the
      // boundary's own reset does not clear a corrupted DataGrid render tree,
      // so the crash takes out the rest of the SPA session until a hard reload
      // (found by a full-module crawl, 2026-08-23).
      //
      // MUI already computes the formatted value correctly, with the right
      // signature, before renderCell ever runs — it's on `formattedValue`. Use
      // that instead of re-deriving it.
      if (params.formattedValue !== undefined && params.formattedValue !== null) {
        value = params.formattedValue;
      }

      // Don't render a link for empty or zero values
      if (!value || value === "0.00" || value === "0" || value === 0 || Number(value) === 0) {
        return value;
      }
      return (
        <Link
          onClick={(event) => {
            event.stopPropagation();
          }}
          to={to}
          style={style}
        >
          {value}
        </Link>
      );
    },
    []
  );

  return renderCellLink;
}
